import type { GuideMessage } from '@budgetx/shared';
import styles from './ChatMessages.module.css';

interface Props {
  messages: GuideMessage[];
}

export function ChatMessages({ messages }: Props) {
  return (
    <div className={styles.list}>
      {messages.map((m) => (
        <div key={m.id} className={`${styles.msg} ${styles[m.role]}`}>
          <div className={`${styles.bubble} ${styles[m.role]}`}>
            {m.paragraphs.map((p, i) => (
              <div key={i}>{p}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
